export default __webpack_public_path__ + "fd94934642b61167ec84ae03f2021e12.png";